import { PrerenderRequest } from 'corporate-types';
import SectionHeaderCms from '../../../components/section-header-cms/SectionHeaderCms';
import { SectionHeader } from '../../../models/auto-generated-strapi-types/types/components/SectionHeader';
import { OuterWrapper } from './SectionHeader.style';

type SectionHeaderSectionProps = {
  data: SectionHeader;
} & PrerenderRequest;

const SectionHeaderSection: React.FC<SectionHeaderSectionProps> = ({
  data,
  isPrerenderRequest,
}: SectionHeaderSectionProps) => {
  return (
    <OuterWrapper backgroundColor={data?.backgroundColor}>
      <SectionHeaderCms
        id={data?.id}
        description={data?.description}
        personalization={data?.personalization}
        mainTitle={data?.mainTitle || ''}
        title={data?.title || ''}
        backgroundColor={data?.backgroundColor}
        topIcon={data?.topIcon}
        isPrerenderRequest={isPrerenderRequest}
      />
    </OuterWrapper>
  );
};

export default SectionHeaderSection;
